"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var withNavigateTo_1 = require("./withNavigateTo"); // tslint:disable-next-line: ban-types


exports.withRedirect = function (condition, route) {
  return function (WrappedComponent) {
    var WithRedirect = function WithRedirect(_a) {
      var navigateTo = _a.navigateTo,
          rest = __rest(_a, ["navigateTo"]);

      if (condition()) {
        navigateTo(route);
        return null;
      }

      return react_1.default.createElement(WrappedComponent, __assign({}, rest));
    };

    return withNavigateTo_1.withNavigateTo(WithRedirect);
  };
};